import { render, staticRenderFns } from "./forgot-pass.vue?vue&type=template&id=4edf9db8"
import script from "./forgot-pass.vue?vue&type=script&lang=js"
export * from "./forgot-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4edf9db8')) {
      api.createRecord('4edf9db8', component.options)
    } else {
      api.reload('4edf9db8', component.options)
    }
    module.hot.accept("./forgot-pass.vue?vue&type=template&id=4edf9db8", function () {
      api.rerender('4edf9db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/account/forgot-pass.vue"
export default component.exports